$(function() {
    $('.pull-out-contact__button, .pull-out-contact__close').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('pull-out-contact-active');
    });
});
